import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import EstadoCamaraService from '@app/services/estadoCamara.service';

const Styles = styled.div``;

const SelectEstadoCamara = ({id, value, onChange, isInvalid, isClearable}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        EstadoCamaraService.getAll().then((response) => {
            setItems(response);
            const newOptions = response.map((item) => {
                return {
                    value: item.id_ec,
                    label: item.nombre_ec
                };
            });
            setOptions(newOptions);
            if (typeof value === 'string' || typeof value === 'number') {
                setSelectedValue(
                    newOptions.find((opt) => opt.value === Number(value))
                );
            } else if(Array.isArray(value)){
                setSelectedValue(value.map(va=>({label:va.nombre_ec,value:va.id_ec})));
            }
        });
    }, []);
    return (
        <Styles>
            <Select
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectEstadoCamara.defaultProps = {
    isClearable: false
};

export default SelectEstadoCamara;
